import React from "react";
import { Sliders } from "lucide-react";
import { useApp } from "@/context/AppContext";

const RADIUS_OPTIONS = [
  { value: 2, label: "2 km" },
  { value: 5, label: "5 km" },
  { value: 10, label: "10 km" },
  { value: 20, label: "20 km" },
  { value: 50, label: "50 km" },
  { value: null, label: "Any" },
];

/** Mobile-first pill selector for delivery radius. */
export default function RadiusFilter({ compact = false }) {
  const { radiusKm, setRadiusKm } = useApp();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="radius-filter">
      {!compact && (
        <div className="text-xs uppercase tracking-wider font-semibold text-slate-500 inline-flex items-center gap-1">
          <Sliders className="w-3.5 h-3.5 text-emerald-700" /> Nearby radius
        </div>
      )}
      <div className="inline-flex flex-wrap items-center gap-1 bg-white border border-slate-200 rounded-full p-1">
        {RADIUS_OPTIONS.map((opt) => {
          const active = (opt.value === null && radiusKm === null) || opt.value === radiusKm;
          return (
            <button
              key={opt.label}
              onClick={() => setRadiusKm(opt.value)}
              className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors ${active ? "bg-emerald-700 text-white shadow-sm" : "text-slate-600 hover:bg-slate-50"}`}
              data-testid={`radius-option-${opt.value === null ? "any" : opt.value}`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
